import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {fetchSensorDetails} from "../../../api/sensorApi";  



function useFetchSensorDetails(id, alertThresholdUpdate) {

    const [sensorData, setSensorData] = useState(null);

    const fetchSensor = async () => {
          try {
            const response = await fetchSensorDetails(id);
            setSensorData(response[0]); // assuming response has a `data` field
          } catch (err) {
            toast.error("Cannot fetch sensor info");
          } 
        }

    useEffect(() => {
        fetchSensor();
    }, [id, alertThresholdUpdate]);

    return { sensorData };


}


export default useFetchSensorDetails;